<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-dialog width="500px" :value="value" @input="toggleModal" persistent scrollable>
        <v-card>
            <v-toolbar class="primary"
                       dark
                       text
                       v-if="loadingEvent">
                <div class="text-h6">{{$t('general.seeEvent')}}</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleModal(false)">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-img v-if="!loadingEvent && event.images && event.images.length > 0"
                   :src="event.images[0].url"
                   :aspect-ratio="16/8">
                <v-row class="fill-height flex-column">
                    <v-row justify="space-between">
                        <v-btn text
                               :color="event.featured ? 'yellow' : 'white'"
                               dark
                               icon
                               style="background: rgba(0, 0, 0, 0.2)"
                               @click="toggleFeatured()">
                            <v-icon>star</v-icon>
                        </v-btn>
                        <v-btn text
                               dark
                               icon
                               style="background: rgba(0, 0, 0, 0.2)"
                               @click="toggleModal(false)">
                            <v-icon>clear</v-icon>
                        </v-btn>
                    </v-row>
                    <v-col v-if="event.soldOut"
                                                        class="black-gradient-background text-h6 shrink text-right pa-2"
                                                        >
                        <span class="pa-2 red--text font-weight-bold">{{$t('general.soldOut')}}</span>
                    </v-col>
                </v-row>
            </v-img>
            <v-card-text v-if="loadingEvent">
                <v-row align="center" justify="center" style="min-height: 30vh">
                    <v-progress-circular indeterminate
                                         color="primary">
                    </v-progress-circular>
                </v-row>
            </v-card-text>

            <v-card-text v-else>
                <v-container class="pa-0" fluid>
                    <v-row>
                        <v-col cols="12" class="text-h6">
                            {{event.title}}
                        </v-col>

                        <v-col cols="12" class="text-caption grey--text">
                            {{event.shortDescription}}
                        </v-col>

                        <v-col cols="12" v-if="event.starts">
                            <v-row align="center">
                                <v-icon class="pa-1 pr-2">event</v-icon> {{event.starts | moment('DD/MM/YYYY hh:mma')}}
                            </v-row>
                        </v-col>

                        <v-col cols="12">
                            {{$t('general.availableTickets')}}: {{event.totalAvailable}}
                        </v-col>

                        <v-col cols="12">
                            {{$t('general.soldTickets')}}: {{event.totalSold}}
                        </v-col>

                        <v-col cols="12">
                            {{$t('general.totalTickets')}}: {{event.totalTickets}}
                        </v-col>

                        <v-col cols="12">
                            <v-switch @change="togglePublish()" :label="$t('general.publishEvent')" v-model="event.publish"></v-switch>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-tooltip right>
                    <template v-slot:activator="{on}">
                        <v-btn :loading="exportingData"
                               color="primary"
                               icon
                               outlined
                               v-on="on"
                               @click="exportAttendees()">
                            <v-icon>
                                cloud_download
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>{{$t('general.exportAssistants')}}</span>
                </v-tooltip>
                <v-spacer></v-spacer>
                <v-btn @click="toggleModal(false)" text color="primary">{{$t('general.accept')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import notifications from '@/libs/notifications'
import eventsService from '@/services/eventsService'

export default {
  data () {
    return {
      exportingData: false,
      loading: false,
      loadingEvent: false,
      filtersSms: '',
      event: {
        title: '',
        shortDescription: '',
        longDescription: '',
        starts: '',
        ends: '',
        featured: false,
        place: '',
        location: '',
        planner: '',
        socialLinks: [],
        contacts: [],
        images: [],
        type: '',
        category: '',
        tickets: []
      }
    }
  },
  methods: {
    exportAttendees () {
      this.exportingData = true
      eventsService.exportData(
        this.$store.getters.token,
        this.$store.getters.companyUuid,
        this.$store.getters.appUuid,
        this.event._id,
        'Asistentes'
      ).then(() => {
        this.exportingData = false
        notifications.success(`${this.$t('general.assistantsExportedSuccessfully')}`)
      }).catch(error => {
        this.exportingData = false
        notifications.error(error.message)
      })
    },
    resetEvent () {
      this.event = {
        title: '',
        shortDescription: '',
        longDescription: '',
        starts: '',
        ends: '',
        featured: '',
        place: '',
        location: '',
        planner: '',
        socialLinks: [],
        contacts: [],
        images: [],
        type: '',
        category: '',
        tickets: []
      }
    },
    toggleFeatured () {
      this.event.featured = !this.event.featured
      eventsService.updateEventProperty(
        this.$store.getters.token,
        this.$store.getters.companyUuid,
        this.$store.getters.appUuid,
        this.event._id,
        { featured: this.event.featured }
      ).then(() => {
        notifications.success(`${this.$t('general.updatedCorrectly')}`)
      }).catch(error => {
        this.event.featured = !this.event.featured
        notifications.error(error.message)
      })
    },
    toggleModal (value) {
      this.resetEvent()
      this.$emit('input', value)
    },
    togglePublish () {
      eventsService.updateEventProperty(
        this.$store.getters.token,
        this.$store.getters.companyUuid,
        this.$store.getters.appUuid,
        this.event._id,
        { publish: this.event.publish }
      ).then(() => {
        notifications.success(`${this.$t('general.eventStateUpdated')}`)
        this.$store.dispatch('getEvents')
      }).catch(error => {
        this.event.publish = !this.event.publish
        notifications.error(error.message)
      })
    }
  },
  props: ['selectedEvent', 'value'],
  watch: {
    selectedEvent (value) {
      if (value) {
        this.loadingEvent = true
        this.$store.dispatch('getEvent', { eventId: value }).then(response => {
          this.loadingEvent = false
          const keys = Object.keys(response)
          keys.forEach(item => {
            this.$set(this.event, item, response[item])
          })
        }).catch(error => {
          this.loadingEvent = false
          console.log(error)
        })
      } else {
        this.resetEvent()
      }
    }
  }
}
</script>
